import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResponsiveService } from '../../../services/responsive.service';
import { ToastrService } from 'ngx-toastr';
import { AdminPortalService } from '../service/admin-portal.service';
import { CommonService } from 'src/app/services/common.service';
import { ManageBrands } from 'src/app/shared/models/admin-portal.model';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-manage-brands',
  templateUrl: './manage-brands.component.html',
  styleUrls: ['./manage-brands.component.css']
})
export class ManageBrandsComponent implements OnInit {
  mobile: boolean;
  allBrands: ManageBrands[];
  pageSize = 5;
  pageIndex = 0;

  constructor(
    public dialogRef: MatDialogRef<ManageBrandsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private responsiveService: ResponsiveService,
    private toastr: ToastrService,
    private AdminPortalService: AdminPortalService,
    private commonService: CommonService
  ) {
    this.mobile = false;
    this.allBrands = [];
  }

  ngOnInit(): void {
    this.brandData();
  }

  /**
   * Brands Data for the selection list and table
   */
  brandData() {
    this.AdminPortalService.getBrandsDetails().subscribe(
      (data) => {
        if (data?.length) {
          this.allBrands = data;
          this.allBrands.forEach((brand) => {
            brand.brandImage = this.commonService.decodeBase64ToImage(brand?.brandImage);
          });
        }
      },
      (error) => {
        this.toastr.error("Error in loading brands!");
      }
    );
  }

  /**
   * Getter for paginated brands
   */
  get pagedBrands(): ManageBrands[] {
    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    return this.allBrands.slice(start, end);
  }

  /**
   * Handle paginator change
   */
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
  }

  /**
   * Toggle brand visibility
   */
  toggleBrandVisibility(brand: ManageBrands): void {
    this.AdminPortalService.changeBrandsVisibility(brand.id, brand.active).subscribe(
      (data) => {},
      (error) => {
        this.toastr.error("Unable to switch the toggle");
      }
    );
  }

  /**
   * Close dialog
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
